import { useMutation } from '@tanstack/react-query';
import { updateVision } from 'shared/services/backend-api';
import { UpdateVision } from 'shared/types/vision';

export const useUpdateVisionMutation = () =>
  useMutation({
    mutationFn: async (vision: UpdateVision) => updateVision(vision),
  });
